import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'

const RecordPosition = ({ isOpen, onClose, currentPosition, recordId, onUpdatePosition, moduleName = "Record" }) => {
    const [moveToPosition, setMoveToPosition] = useState('')

    useEffect(() => {
        if (isOpen) {
            setMoveToPosition('')
        }
    }, [isOpen])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!moveToPosition || moveToPosition.trim() === '') {
            Swal.fire({
                title: 'Error',
                text: 'Please enter a position to move to.',
                icon: 'error'
            })
            return
        }

        const position = parseInt(moveToPosition)
        if (isNaN(position) || position < 1) {
            Swal.fire({
                title: 'Error',
                text: 'Position must be a valid positive number.',
                icon: 'error'
            })
            return
        }

        if (position === currentPosition) {
            Swal.fire({
                title: 'Info',
                text: 'The record is already at this position.',
                icon: 'info'
            })
            return
        }

        try {
            if (onUpdatePosition) {
                await onUpdatePosition(recordId, position)
                Swal.fire({
                    title: 'Success',
                    text: `${moduleName} position updated successfully`,
                    icon: 'success'
                })
                onClose()
            }
        } catch (error) {
            console.error('Error updating position:', error)
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to update position',
                icon: 'error'
            })
        }
    }

    if (!isOpen) return null

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">
                        Update {moduleName} Position
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl"
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Current Position
                        </label>
                        <input
                            type="number"
                            value={currentPosition || ''}
                            readOnly
                            className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Move To Position <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            value={moveToPosition}
                            onChange={(e) => setMoveToPosition(e.target.value)}
                            min="1"
                            required
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter new position"
                        />
                    </div>

                    <div className="flex justify-end space-x-3 pt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            Update Position
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default RecordPosition

